import { render, staticRenderFns } from "./ChannelSetting.vue?vue&type=template&id=8e14f536&scoped=true"
import script from "./ChannelSetting.vue?vue&type=script&lang=js"
export * from "./ChannelSetting.vue?vue&type=script&lang=js"
import style0 from "./ChannelSetting.vue?vue&type=style&index=0&id=8e14f536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e14f536",
  null
  
)

export default component.exports